/* Ventry — ventry.js
   Dependency-free interactions. Everything degrades gracefully without JS. */
(function () {
  "use strict";

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Sticky header blur on scroll ---------- */
  var header = document.querySelector("[data-header]");
  if (header) {
    var onScroll = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 24);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------- Mobile menu overlay ---------- */
  var menu = document.querySelector("[data-mobile-menu]");
  var openBtns = document.querySelectorAll("[data-menu-open]");
  var closeBtns = document.querySelectorAll("[data-menu-close]");
  function setMenu(open) {
    if (!menu) return;
    menu.classList.toggle("is-open", open);
    document.body.style.overflow = open ? "hidden" : "";
  }
  openBtns.forEach(function (b) { b.addEventListener("click", function () { setMenu(true); }); });
  closeBtns.forEach(function (b) { b.addEventListener("click", function () { setMenu(false); }); });
  if (menu) {
    menu.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () { setMenu(false); });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") setMenu(false);
    });
  }

  /* ---------- Accordions (single-open per group) ---------- */
  document.querySelectorAll("[data-accordion]").forEach(function (group) {
    group.querySelectorAll("[data-accordion-trigger]").forEach(function (trigger) {
      var item = trigger.closest("[data-accordion-item]");
      var panel = item.querySelector("[data-accordion-panel]");
      // Set initial heights for pre-opened items
      if (item.classList.contains("is-open")) {
        panel.style.maxHeight = panel.scrollHeight + "px";
        trigger.setAttribute("aria-expanded", "true");
      }
      trigger.addEventListener("click", function () {
        var isOpen = item.classList.contains("is-open");
        // close siblings
        group.querySelectorAll("[data-accordion-item].is-open").forEach(function (other) {
          other.classList.remove("is-open");
          other.querySelector("[data-accordion-panel]").style.maxHeight = "0px";
          other.querySelector("[data-accordion-trigger]").setAttribute("aria-expanded", "false");
        });
        if (!isOpen) {
          item.classList.add("is-open");
          panel.style.maxHeight = panel.scrollHeight + "px";
          trigger.setAttribute("aria-expanded", "true");
        }
      });
    });
  });
  // Recalculate open accordion heights on resize
  window.addEventListener("resize", function () {
    document.querySelectorAll("[data-accordion-item].is-open [data-accordion-panel]").forEach(function (p) {
      p.style.maxHeight = p.scrollHeight + "px";
    });
  });

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll(".reveal, .reveal-group, [data-draw], .dist");
  if ("IntersectionObserver" in window && !reduced) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add(entry.target.hasAttribute("data-draw") ? "is-drawn" : "is-visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: "0px 0px -8% 0px" });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) {
      el.classList.add(el.hasAttribute("data-draw") ? "is-drawn" : "is-visible");
    });
  }

  /* ---------- Count-up numbers ---------- */
  function animateCount(el) {
    var target = parseFloat(el.getAttribute("data-countup"));
    if (isNaN(target)) return;
    var decimals = parseInt(el.getAttribute("data-decimals") || "0", 10);
    var suffix = el.getAttribute("data-suffix") || "";
    var prefix = el.getAttribute("data-prefix") || "";
    if (reduced) {
      el.textContent = prefix + target.toFixed(decimals) + suffix;
      return;
    }
    var dur = 1200;
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 4);
      el.textContent = prefix + (target * eased).toFixed(decimals) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  var counters = document.querySelectorAll("[data-countup]");
  if ("IntersectionObserver" in window) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCount(entry.target);
          cio.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    counters.forEach(function (el) { cio.observe(el); });
  } else {
    counters.forEach(animateCount);
  }

  /* ---------- Edition switcher tabs ----------
     Scope: [data-edition-scope]. Buttons: [data-edition-target="18-24"].
     Panes: [data-edition-pane="18-24"]. Sets --accent on scope and syncs ?edition=

     Reliability rules:
     - The critical path (pill state + pane visibility) runs FIRST and is never
       wrapped with code that can throw.
     - Every enhancement (accent, labels, links, URL sync, cross-scope sync) is
       isolated in its own try/catch so a failure can never block the switch.
     - Scopes are bound once (data-edition-bound) and re-bound after theme-editor
       section reloads (shopify:section:load), so no double-binding and no dead
       buttons after the editor re-renders a section.
     - The ?edition= URL param is only consulted once, at initial bind; clicks
       always win afterwards. */
  function activateScope(scope, id, pushUrl, propagate, accentOverride) {
    var btn = scope.querySelector('[data-edition-target="' + id + '"]');
    var hasPane = scope.querySelector('[data-edition-pane="' + id + '"]');
    if (!btn && !hasPane) return;

    /* --- critical path: switch pill + panes --- */
    scope.querySelectorAll("[data-edition-target]").forEach(function (b) {
      var on = b === btn;
      b.classList.toggle("is-active", on);
      b.setAttribute("aria-selected", on ? "true" : "false");
    });
    scope.querySelectorAll("[data-edition-pane]").forEach(function (p) {
      p.classList.toggle("is-active", p.getAttribute("data-edition-pane") === id);
    });

    /* --- enhancements: isolated so nothing below can break the switch --- */
    var accent = accentOverride || (btn ? btn.getAttribute("data-accent") : null);
    if (accent) {
      try { scope.style.setProperty("--accent", accent); } catch (e) {}
    }
    try {
      var label = btn ? btn.getAttribute("data-label") : null;
      scope.querySelectorAll("[data-edition-label]").forEach(function (l) {
        l.textContent = label || id;
      });
      scope.querySelectorAll("[data-edition-link]").forEach(function (a) {
        var url = btn && btn.getAttribute("data-url");
        if (url) a.setAttribute("href", url);
      });
    } catch (e) {}
    if (pushUrl && scope.hasAttribute("data-edition-url-sync")) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set("edition", id);
        window.history.replaceState(null, "", url.toString());
      } catch (e) {}
    }
    if (propagate) {
      try {
        var group = scope.getAttribute("data-edition-group");
        if (group) {
          document.querySelectorAll('[data-edition-group="' + group + '"]').forEach(function (other) {
            if (other === scope) return;
            try { activateScope(other, id, false, false, accent); } catch (e) {}
          });
        }
      } catch (e) {}
    }
  }

  function bindEditionScopes(root) {
    (root || document).querySelectorAll("[data-edition-scope]").forEach(function (scope) {
      if (scope.hasAttribute("data-edition-bound")) return; // no double-binding
      scope.setAttribute("data-edition-bound", "true");

      scope.querySelectorAll("[data-edition-target]").forEach(function (b) {
        b.addEventListener("click", function () {
          activateScope(scope, b.getAttribute("data-edition-target"), true, true);
        });
      });

      // Initial state: URL param wins on first load only, else pre-marked active button
      var initial = null;
      if (scope.hasAttribute("data-edition-url-sync")) {
        try {
          var param = new URLSearchParams(window.location.search).get("edition");
          if (param && scope.querySelector('[data-edition-target="' + param + '"]')) initial = param;
        } catch (e) {}
      }
      if (!initial) {
        var active = scope.querySelector("[data-edition-target].is-active");
        initial = active ? active.getAttribute("data-edition-target") : null;
      }
      if (initial) activateScope(scope, initial, false, true);
    });
  }
  bindEditionScopes(document);
  // Theme editor re-renders sections via AJAX — rebind any new scopes
  document.addEventListener("shopify:section:load", function (e) {
    bindEditionScopes(e.target || document);
  });

  // Cross-scope "choose edition" links: set switcher + scroll to hero
  document.querySelectorAll("[data-choose-edition]").forEach(function (link) {
    link.addEventListener("click", function (e) {
      var id = link.getAttribute("data-choose-edition");
      var scope = document.querySelector("[data-edition-scope]");
      var btn = scope && scope.querySelector('[data-edition-target="' + id + '"]');
      if (btn) {
        e.preventDefault();
        btn.click();
        try {
          var hero = document.querySelector("[data-product-hero]");
          if (hero) hero.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "start" });
        } catch (err) {}
      }
    });
  });

  /* ---------- Framework graph: scroll-drawn arc, travelling dot, day counter,
     milestone scroll-spy. No-JS / reduced-motion fallback: the SVG renders fully
     drawn and every milestone stays lit (JS only enhances). ---------- */
  var phasesWrap = document.querySelector("[data-phases]");
  if (phasesWrap) {
    var graph = phasesWrap.querySelector("[data-phases-graph]");
    var arc = graph && graph.querySelector("[data-arc]");
    var dot = graph && graph.querySelector("[data-arc-dot]");
    var dotRing = graph && graph.querySelector("[data-arc-dot-ring]");
    var dayEl = phasesWrap.querySelector("[data-day-counter]");
    var milestones = graph ? graph.querySelectorAll("[data-milestone]") : [];
    var phaseCards = phasesWrap.querySelectorAll("[data-phase]");
    var dayPrefix = (graph && graph.getAttribute("data-day-prefix")) || "DAY";
    var totalDays = parseInt((graph && graph.getAttribute("data-total-days")) || "21", 10) || 21;
    var arcLen = 0;
    if (arc) {
      try { arcLen = arc.getTotalLength(); } catch (e) { arcLen = 0; }
    }

    function setDayCounter(day) {
      if (!dayEl) return;
      dayEl.textContent = dayPrefix + " " + String(day).padStart(2, "0") + " → " + dayPrefix + " " + totalDays;
    }

    function renderGraph(p) {
      // p: 0 = nothing drawn, 1 = full arc
      arc.style.strokeDasharray = String(arcLen);
      arc.style.strokeDashoffset = String(arcLen * (1 - p));
      if (dot) {
        try {
          var pt = arc.getPointAtLength(arcLen * p);
          dot.setAttribute("cx", pt.x);
          dot.setAttribute("cy", pt.y);
          if (dotRing) { dotRing.setAttribute("cx", pt.x); dotRing.setAttribute("cy", pt.y); }
        } catch (e) {}
      }
      setDayCounter(Math.max(1, Math.min(totalDays, Math.round(1 + p * (totalDays - 1)))));
    }

    if (graph && arc && arcLen > 0 && !reduced) {
      // Animated mode: draw arc with scroll progress through the section
      graph.classList.add("is-animated");
      var graphTicking = false;
      var updateGraph = function () {
        graphTicking = false;
        var rect = phasesWrap.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        // 0 when section top reaches 80% of viewport, 1 when section bottom reaches 80%
        var p = (vh * 0.8 - rect.top) / Math.max(rect.height, 1);
        p = Math.max(0, Math.min(1, p));
        renderGraph(p);
      };
      var onGraphScroll = function () {
        if (!graphTicking) {
          graphTicking = true;
          requestAnimationFrame(updateGraph);
        }
      };
      window.addEventListener("scroll", onGraphScroll, { passive: true });
      window.addEventListener("resize", onGraphScroll);
      updateGraph();
    } else {
      // Static fallback: fully drawn arc, full-range counter, all milestones lit
      setDayCounter(totalDays);
      milestones.forEach(function (m) { m.classList.add("is-lit"); });
    }

    // Milestone scroll-spy: light each milestone as its phase row enters view
    if ("IntersectionObserver" in window && phaseCards.length) {
      phasesWrap.classList.add("phases--js");
      var pio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          phaseCards.forEach(function (c) { c.classList.remove("is-active"); });
          entry.target.classList.add("is-active");
          var idx = Array.prototype.indexOf.call(phaseCards, entry.target);
          if (milestones[idx] && !reduced) milestones[idx].classList.add("is-lit");
        });
      }, { threshold: 0.55 });
      phaseCards.forEach(function (c) { pio.observe(c); });
    } else {
      // No IntersectionObserver: everything stays fully visible
      phaseCards.forEach(function (c) { c.classList.add("is-active"); });
      milestones.forEach(function (m) { m.classList.add("is-lit"); });
    }
  }

  /* ---------- Review wall filters ---------- */
  document.querySelectorAll("[data-review-wall]").forEach(function (wallSection) {
    var wall = wallSection.querySelector("[data-review-grid]");
    var cards = Array.prototype.slice.call(wallSection.querySelectorAll("[data-review-card]"));
    var editionPills = wallSection.querySelectorAll("[data-filter-edition]");
    var starRows = wallSection.querySelectorAll("[data-filter-stars]");
    var sortSelect = wallSection.querySelector("[data-sort]");
    var emptyMsg = wallSection.querySelector("[data-review-empty]");
    var state = { edition: "all", stars: 0 };

    function apply() {
      var visible = 0;
      cards.forEach(function (card) {
        var okEdition = state.edition === "all" || card.getAttribute("data-edition") === state.edition;
        var okStars = state.stars === 0 || parseInt(card.getAttribute("data-stars"), 10) === state.stars;
        var show = okEdition && okStars;
        card.classList.toggle("is-hidden", !show);
        if (show) {
          visible++;
          if (!reduced) {
            card.style.animation = "none";
            void card.offsetWidth;
            card.style.animation = "pane-in 0.4s var(--ease-out)";
          }
        }
      });
      if (emptyMsg) emptyMsg.hidden = visible !== 0;
    }

    editionPills.forEach(function (pill) {
      pill.addEventListener("click", function () {
        editionPills.forEach(function (p) { p.classList.remove("is-active"); p.setAttribute("aria-pressed", "false"); });
        pill.classList.add("is-active");
        pill.setAttribute("aria-pressed", "true");
        state.edition = pill.getAttribute("data-filter-edition");
        apply();
      });
    });

    starRows.forEach(function (row) {
      row.addEventListener("click", function () {
        var val = parseInt(row.getAttribute("data-filter-stars"), 10);
        var already = state.stars === val;
        state.stars = already ? 0 : val;
        starRows.forEach(function (r) {
          var rv = parseInt(r.getAttribute("data-filter-stars"), 10);
          r.classList.toggle("is-dim", state.stars !== 0 && rv !== state.stars);
        });
        apply();
      });
    });

    if (sortSelect) {
      sortSelect.addEventListener("change", function () {
        var mode = sortSelect.value;
        var sorted = cards.slice().sort(function (a, b) {
          var sa = parseInt(a.getAttribute("data-stars"), 10);
          var sb = parseInt(b.getAttribute("data-stars"), 10);
          var ia = parseInt(a.getAttribute("data-index"), 10);
          var ib = parseInt(b.getAttribute("data-index"), 10);
          if (mode === "highest") return sb - sa || ia - ib;
          if (mode === "lowest") return sa - sb || ia - ib;
          return ia - ib;
        });
        sorted.forEach(function (c) { wall.appendChild(c); });
        apply();
      });
    }

    apply();
  });

  /* ---------- Smooth anchor scrolling (native fallback is fine) ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener("click", function (e) {
      var id = a.getAttribute("href").slice(1);
      var target = id && document.getElementById(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "start" });
      }
    });
  });
})();
